import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { BookIcon } from './Icons';
export function PathSection() {
  const weeks = [{
    week: 'Semana 1',
    focus: 'El Despertar del Hambre',
    transform: 'Identificas el ruido, creas el silencio, enciendes el deseo real'
  }, {
    week: 'Semana 2',
    focus: 'Descubriendo el Rostro del Amigo',
    transform: 'La imagen distorsionada de Jesús se reemplaza por la real de los Evangelios'
  }, {
    week: 'Semana 3',
    focus: 'La Batalla del Pensamiento',
    transform: 'Los 3 Filtros operando en decisiones reales y cotidianas'
  }, {
    week: 'Semana 4',
    focus: 'Viviendo en Tabernáculo Abierto',
    transform: "La Presencia integrada en toda tu vida, no solo en 'momentos espirituales'"
  }];
  return <section className="bg-cream-dark pt-12 pb-24 px-4" data-id="element-209">
      <div className="max-w-4xl mx-auto" data-id="element-210">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-211">
          <BookIcon className="w-12 h-12 text-olive mx-auto mb-6" data-id="element-212" />
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-dark mb-6" data-id="element-213">
            El Camino de 30 Días
          </h2>
          <p className="text-xl text-dark/70" data-id="element-214">
            El protocolo no es una lista de obligaciones religiosas. Es un mapa
            progresivo:
          </p>
        </motion.div>

        <div className="space-y-4 mb-16" data-id="element-215">
          {weeks.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 md:p-8 rounded-lg shadow-sm border border-dark/5 flex flex-col md:flex-row gap-6 items-start md:items-center" data-id="element-216">
              <div className="bg-olive text-cream px-4 py-2 rounded font-bold whitespace-nowrap" data-id="element-217">
                {item.week}
              </div>
              <div className="flex-1" data-id="element-218">
                <h4 className="text-xl font-serif font-bold text-dark mb-2" data-id="element-219">
                  {item.focus}
                </h4>
                <p className="text-dark/70" data-id="element-220">{item.transform}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-olive text-cream p-8 md:p-12 rounded-xl text-center relative overflow-hidden" data-id="element-221">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(197,165,90,0.2),transparent_70%)]" data-id="element-222" />
          <div className="relative z-10" data-id="element-223">
            <h3 className="text-2xl font-bold mb-6 text-gold" data-id="element-224">
              La única métrica de éxito de la Semana 1:
            </h3>
            <p className="text-lg mb-4" data-id="element-225">
              No cuántas veces oraste. No cuántos versículos memorizaste.
            </p>
            <p className="text-2xl font-serif font-bold mb-8" data-id="element-226">
              ¿Sientes más hambre de Él al final de la semana que al principio?
            </p>
            <p className="font-serif italic text-gold/90 text-xl" data-id="element-227">
              "Bienaventurados los que tienen hambre y sed de justicia, porque
              ellos serán saciados." — Mateo 5:6
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}